#import "../fragments/form-fragment.graphql"

mutation UpdateForm($input: FormUpdateInput!) {
    formUpdate(input: $input) {
        form {
            ...FormFragment
        }
    }
}
